import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom';
import "../css/MainTitleBreadcrumb.css"
const MainTitleBreadcrumb = () => {

    const [paramsRequest, setParamsRequest] = useState([])
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const modelName = searchParams.get('model');
    useEffect(() => {
        if (location.pathname == "/urunler") {
            const data = [{
                name: "Ürünler", url: "/urunler?sıralama=modelkodu"
            }]
            if (modelName == "PERVAZ") {
                data.push({ name: "Pervazlar", url: "/urunler?model=PERVAZ&sıralama=modelkodu" });
            }
            else if (modelName == "KASA") {
                data.push({ name: "Kasalar", url: "/urunler?model=KASA&sıralama=modelkodu" });
            }
            else if (modelName) {
                const formattedModelName = modelName.charAt(0).toUpperCase() + modelName.slice(1).toLowerCase();
                data.push({ name: `${formattedModelName} Kapılar`, url: `/urunler?model=${modelName}&sıralama=modelkodu` });
            }
            setParamsRequest(data)
        }
        else if (location.pathname == "/biz-kimiz") {
            const data = [{
                name: "Hakkımızda", url: undefined
            },
            {
                name: "Biz Kimiz", url: "/biz-kimiz"
            }]
            setParamsRequest(data)
        }
        else if (location.pathname == "/surecler") {
            const data = [{
                name: "Hakkımızda", url: undefined
            },
            {
                name: "Süreçlerimiz", url: "/surecler"
            }]
            setParamsRequest(data)
        }
        else if (location.pathname == "/referanslar") {
            const data = [{
                name: "Hakkımızda", url: undefined
            },
            {
                name: "Referanslarımız", url: "/referanslar"
            }]
            setParamsRequest(data)
        }
        else if (location.pathname == "/e-katalog") {
            const data = [{
                name: "E-Katalog", url: "/e-katalog"
            }]
            setParamsRequest(data)
        }
        else if (location.pathname == "/iletisim") {
            const data = [{
                name: "İletişim", url: "/iletisim"
            }]
            setParamsRequest(data)
        }
        else if (location.pathname == "/trafik-akisi") {
            const data = [{
                name: "Trafik Akışı", url: "/trafik-akisi"
            }]
            setParamsRequest(data)
        }
    }, [location.pathname]);

    return (
        <div className='main-title-breadcrumb-container'>
            <div className='main-title-breadcrumb'>
                <ul>
                    <li><a href="/">
                        <p>Ana Sayfa</p>
                    </a></li>
                    {paramsRequest && paramsRequest.map((data, index) => {
                        const isLastItem = index == paramsRequest.length - 1;
                        return (
                            <li className={`${isLastItem ? "active" : ""}`} style={{ marginRight: isLastItem ? "0px" : "30px", cursor: isLastItem ? "auto" : "" }}>
                                <a href={isLastItem ? undefined : data.url}>
                                    <p>{data.name}</p>
                                </a>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </div>
    )
}

export default MainTitleBreadcrumb